export default {
    getSubscriptionTypes() {
        const url = 'v1/subscription-types';
        return this.$axios.$get(url);
    },
};
